import { render, staticRenderFns } from "./RemnantFamily.vue?vue&type=template&id=3927fed1&scoped=true"
import script from "./RemnantFamily.vue?vue&type=script&lang=js"
export * from "./RemnantFamily.vue?vue&type=script&lang=js"
import style0 from "./RemnantFamily.vue?vue&type=style&index=0&id=3927fed1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3927fed1",
  null
  
)

export default component.exports